import { render, staticRenderFns } from "./PrestationHotel.vue?vue&type=template&id=41190f82"
import script from "./PrestationHotel.vue?vue&type=script&lang=js"
export * from "./PrestationHotel.vue?vue&type=script&lang=js"
import style0 from "./PrestationHotel.vue?vue&type=style&index=0&id=41190f82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports